import { Button, CloseButton, Col, Modal, Row, Stack } from "react-bootstrap"
import { TextButton } from "Components/Button";
import WarningIcon from '@mui/icons-material/WarningAmberRounded';

const ConfirmDeleteBatchPopup = ({
  show,
  handleClose,
  handleDelete,
  selected
}) => {

  const cancel = () => {
    handleClose();
  }

  const deleteBatch = () => {
    handleDelete();
    handleClose();
  }

  return (

    <Modal className="modal" size="lg" backdrop="static" keyboard={false} show={show} onHide={handleClose} >
      <Modal.Header className="m-3">
        <Modal.Title >Delete Confirmation</Modal.Title>
        <CloseButton className="align-self-start" onClick={handleClose}></CloseButton>
      </Modal.Header>
      <Modal.Body>
        <Stack direction="horizontal" className="page-info--warning">
          <div className="icon-container">
            <WarningIcon fontSize="small"></WarningIcon>
          </div>
          <div className="message">
            Are you sure you want to delete ({selected?.selectedCount}) batch{selected?.selectedCount > 1 ? "es" : ""}?
          </div>
        </Stack>
      </Modal.Body>
      <Modal.Footer>
        <Row className="mb-4 float-end">
          <Col lg={4}>
            <Stack className="pt-3" direction="horizontal" gap={3}>
              <TextButton
                variant="normal"
                onClick={deleteBatch}
                content={"Yes"}
                autoFocus={true}
              >
              </TextButton>
            </Stack>
          </Col>
          <Col>
            <Stack className="pt-3 float-end" direction="horizontal" gap={3}>
              {/* Back Button */}
              <TextButton
                variant="outline"
                onClick={cancel}
                content={"No"}
              >
              </TextButton>
            </Stack>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>


    // <Modal className="modal" size="lg" backdrop="static" show={show} centered>
    //   <Modal.Body className="m-3">
    //     <div className="pb-3 mb-3"><CloseButton className="closeup-popup-button" onClick={cancel}></CloseButton></div>
    //     {/* <h1 className="text-start">Delete Batch(es)</h1> */}
    //     <h1 >Delete Confirmation</h1>
    //     <Row className="mt-3">
    //       <Col>
    //         Are you sure you want to delete the selected batch(es)?
    //       </Col>
    //     </Row>
    //     <Row className="mb-4 float-end">
    //       <Col lg={4}>
    //         <Stack className="pt-3" direction="horizontal" gap={3}>
    //           <TextButton
    //             variant="normal"
    //             onClick={deleteBatch}
    //             content={"Yes"}
    //           >
    //           </TextButton>
    //         </Stack>
    //       </Col>
    //       <Col>
    //         <Stack className="pt-3 float-end" direction="horizontal" gap={3}>
    //           {/* Back Button */}
    //           <TextButton
    //             variant="outline"
    //             onClick={cancel}
    //             content={"No"}
    //           >
    //           </TextButton>
    //         </Stack>
    //       </Col>
    //     </Row>
    //   </Modal.Body>
    // </Modal>


  )
}

export default ConfirmDeleteBatchPopup;